import { Component, effect, inject, input, model } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { RateAlertStore } from '../../store/rate-alert.store';
import { MatDialog } from '@angular/material/dialog';
import { ManageAlertComponent } from '../manage-alert/manage-alert.component';
import { Rate } from 'src/app/shared/models/rate';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'alert-button',
  imports: [MatIconModule, MatBadgeModule, MatButtonModule, MatTooltipModule],
  templateUrl: './alert-button.component.html',
  styleUrl: './alert-button.component.scss',
})
export class AlertButtonComponent {
  fromCurrency = input.required<string>();
  toCurrency = input('CAD');
  tradeType = input.required<'buy' | 'sell'>();
  alertStore = inject(RateAlertStore);
  readonly dialog = inject(MatDialog);
  alertCount = 0;
  rate = model.required<Rate>();

  readonly _effect = effect(() => {
    this.alertCount = this.alertStore
      .list()
      ?.filter((it) => it.fromCurrencyAbbr == this.fromCurrency() && it.toCurrencyAbbr == this.toCurrency() && it.tradeType == this.tradeType()).length;
  });

  onClickOpenManageDialog() {
    this.dialog.open(ManageAlertComponent, {
      data: {
        fromCurrency: this.fromCurrency(),
        toCurrency: this.toCurrency(),
        tradeType: this.tradeType(),
        rate: this.rate(),
      },
      height: '400px',
      width: '650px',
    });
  }
}
